import { MockLocationStrategy } from '@angular/common/testing';

import { ENVIRONMENT } from './environment.enum';
import Environment from './environment.interface';

export const environment: Environment = {
    production: true,
    environment: ENVIRONMENT.production,
    locationStrategy: MockLocationStrategy,
    baseHref: 'https://abertura-conta-agro.cloud.itau.com.br/',
    ambienteLikert: 'prod',
    baseCharonUrl: 'https://apicd.cloud.itau.com.br/charon/kmx5dcrz',
    initSessionUrl: 'https://caronte.cyberdefense.prod.aws.cloud.ihf/iske',
    base: 'https://apicd.cloud.itau.com.br/charon/',
    charonCripto: true,
    charonID: 'kmx5dcrz',
    analyticsSDKUrl: 'https://www.itau.com.br/sdk-analytics/index.js',
    analyticsGtmId: 'GTM-W2D4FGX',
    logConfig: {
        name: "lt2-onboarding-agro",
        sigla: "lt2",
        env: 'prod',
        version: '1.0.0',
        externalApplication: true,
        datadog: {
            logs: {
                clientToken: 'pube3e2dca3ed683373e9a468f2d26244b1'
            },
            rum: {
                enablePrivacyForActionName: true,
                applicationId: 'cf034bbe-5f79-4831-a14f-372d06a0ef7c',
                clientToken: 'pube3e2dca3ed683373e9a468f2d26244b1'
            }
        }
    },
    fullstory: {
        organizationID: 'o-21CERD-na1',
        sampling: 1
    },
    cesScriptUrl:
        "https://survey-satisfaction.cloud.itau.com.br/lit/ces/ces.js",
};